import React, { useState } from "react";
import styled from "styled-components";
import MainLayoutWrapper from "../../../components/wrappers/mainLayoutWrapper";
import Logo from "../../../assets/logoN3_transparent.png";
import "./loginScreen.css";
import { LoginMethod } from "../../../enum/loginMethod.enum";
import EmailLogin from "./components/EmailLogin/EmailLogin";
import { Link, useHistory } from "react-router-dom";
import firebase from "firebase/app";
import { toast } from "react-toastify";
import Toastify from "../../../components/toastify/Tostify";
import { SignInWithGoogle, SignInWithFacebook } from "../../../utils/firebase";
const LoginModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 70vw;
  border-radius: 15px;
  align-items: center;
`;

const LoginActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 55vw;
`;

const LoginScreen = () => {
  const [loginMethod, setLoginMethod] = useState(LoginMethod.Email);
  const history = useHistory();

  // Handle Facebook Login
  const loginWithFacebook = () => {
    history.push("/login?auth=facebook");
    try {
      SignInWithFacebook()
        .then(() => {
          history.push("/home");
        })
        .catch((err) => {
          let errorMessage = err.message;
          console.log(errorMessage);
          // setError(errorMessage);
        });
    } catch (e) {
      let errorMessage = e.message;
      console.log(errorMessage);
      // setError(errorMessage);
    }
  };
  // Handle Google Sign In
  const loginWithGoogle = () => {
    debugger;
    // history.push("/login?auth=google");
    try {
      SignInWithGoogle()
        .then(() => {
          history.push("/home");
        })
        .catch((err) => {
          let errorMessage = err.message;
          console.error(errorMessage);
          // setError(errorMessage);
        });
    } catch (e) {
      let errorMessage = e.message;
      console.error(errorMessage);
      // setError(errorMessage);
    }
  };

  const handleEmailLogin = ({ email, password }) => {
    console.log("email : ", email);
    console.log("password : ", password);
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        if (result) {
          console.log("logged in ");
          history.push("/");
          toast.success("Welcome back!");
        }
      })
      .catch((err) => {
        console.log(err.code);
        if (err.code == "auth/user-not-found") {
          toast.error("Wrong email or password!");
        }
      });
  };

  return (
    <MainLayoutWrapper>
      <Toastify />
      <LoginModal>
        <img
          src={Logo}
          style={{
            backgroundSize: "contain",
            width: 280,
            height: 280,
            marginTop: -25,
          }}
        />
        <EmailLogin handleEmailLogin={handleEmailLogin} />
      </LoginModal>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "40px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div onClick={loginWithFacebook}>
            <img
              src="https://img.icons8.com/color/96/null/facebook-new.png"
              alt={"facebook"}
              style={{ height: "30px", width: "30px" }}
            />
          </div>
          <div onClick={loginWithGoogle}>
            <img
              src="https://img.icons8.com/color/96/null/google-logo.png"
              alt={"google"}
              style={{ height: "30px", width: "30px" }}
            />
          </div>
        </div>
      </div>
      <LoginActions>
        <a onClick={() => history.push("/reset-password")}>Forgot password ?</a>
        <a onClick={() => history.push("/register")}>
          Don't have an account? Sign up!
        </a>
      </LoginActions>
    </MainLayoutWrapper>
  );
};

export default LoginScreen;
